import appConfig from '../../../config/appConfig';

var config = {
  apiUrl: appConfig.apiUrl + 'withdrawalreceipts/'
};

export default config;


// WEBPACK FOOTER //
// ./src/components/withdrawalreceipts/config/withdrawalreceiptConfig.js